import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SharingVendorBody extends PrimitiveValueObject<string> {
  static create(value: string): SharingVendorBody {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorBody(value);
  }
}
